import React from "react";
import SeoHead from "../../../../components/SeoHead";
import EventOrganizersHero from "../event-organizers/EventOrganizersHero";
import SmartPlatform from "../event-organizers/SmartPlatform";
import PaymentStruggles from "../event-organizers/PaymentStruggles";
import WhyOrganizersLove from "../event-organizers/WhyOrganizersLove";
import HowNdovuWorks from "../event-organizers/HowNdovuWorks";
import { msmesConfig as config } from "../serviceConfig";

function MSMEs() {
  return (
    <div id="msmes">
      <SeoHead title="SMEs &amp; MSMEs" description="Run your SME without money leaks. Automate payroll, expenses and supplier payments with NdovuPay — everything in one place." path="/services/msmes" />
      <EventOrganizersHero hero={config.hero} />
      <SmartPlatform platform={config.platform} />
      <PaymentStruggles struggles={config.struggles} />
      <HowNdovuWorks how={config.how} />
      <WhyOrganizersLove why={config.why} />
    </div>
  );
}

export default MSMEs;
